// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1vZAF","head":"ProcedureTableInfo_head__kuuju"};